import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Alterar Categoria de Link ", -1)
const _hoisted_2 = { class: "col-md-12 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_4 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Obervação", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Salvar")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, " Links Vinculadas a Categoria", -1)
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Add Links")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table table-striped table-sm" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Remover"),
    /*#__PURE__*/_createElementVNode("th", null, "Link")
  ])
], -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Atualizar", -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.short_name) = $event)),
            class: "form-control",
            name: "short_name"
          }, null, 512), [
            [_vModelText, $setup.data.short_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.long_name) = $event)),
            class: "form-control",
            name: "long_name"
          }, null, 512), [
            [_vModelText, $setup.data.long_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.note) = $event)),
            class: "form-control",
            name: "note"
          }, null, 512), [
            [_vModelText, $setup.data.note]
          ])
        ]),
        _hoisted_12
      ], 32),
      _createElementVNode("div", null, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeCategoriaLink && $setup.storeCategoriaLink(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedLinks) = $event)),
              class: "form-select",
              multiple: "",
              "aria-label": "multiple select example"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.linkdisp, (link) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: link.id,
                  value: link.id
                }, _toDisplayString(link.id) + " . " + _toDisplayString(link.short_name) + " -> " + _toDisplayString(link.long_name), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedLinks]
            ])
          ]),
          _hoisted_17
        ], 32),
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeCategoriaLinkUpdate && $setup.storeCategoriaLinkUpdate(...args)), ["prevent"]))
        }, [
          ($setup.data.showtableFunc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("table", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoriaLinks, (link) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: link.id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.excSelLinks) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              value: link.id
                            }, null, 8, _hoisted_22), [
                              [_vModelCheckbox, $setup.excSelLinks]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(link.id) + " . " + _toDisplayString(link.short_name), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.showtableFunc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ])
  ]))
}